import { useEffect } from 'react';
import { useTransitionState } from 'react-transition-state';

import { Context } from './Context';
import { WhenFalse } from './WhenFalse';
import { WhenTrue } from './WhenTrue';
import type { TransitionType, AnimationState } from './types';

const DEFAULT_SHIMMER_TIMEOUT = 200;

interface Props {
  animateOn: boolean;
  timeout?: number;
  transition?: TransitionType;
  children: React.ReactNode;
}

const Animate = ({
  children,
  animateOn,
  timeout = DEFAULT_SHIMMER_TIMEOUT,
  transition = 'fade',
}: Props) => {
  const [transitionState, toggle] = useTransitionState({
    timeout,
    initialEntered: animateOn,
    preEnter: true,
  });

  useEffect(() => {
    toggle(animateOn);
  }, [animateOn, toggle]);

  const state: AnimationState =
    transitionState.status === 'entering' ||
    transitionState.status === 'entered'
      ? 'entered'
      : 'exited';

  return (
    <Context.Provider value={{ transition, state }}>
      {children}
    </Context.Provider>
  );
};

Animate.WhenTrue = WhenTrue;
Animate.WhenFalse = WhenFalse;

export { Animate };
